'use client';

import React from 'react';

export const LazyMoneyBlocks = React.lazy(() =>
  import('./MoneyBlocks').then(module => ({ default: module.MoneyBlocks })),
);
